import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

/**
 * Returns whether Walmart shopping insights are available to this provider.
 * Gated by the `walmart-shopping-insights` GrowthBook flag.
 *
 * When this returns false the Walmart documents request never fires — the
 * underlying query stays disabled, so no call reaches the Berry Street API.
 */
export const useWalmartShoppingInsights = (): boolean => {
  return useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.WALMART_SHOPPING_INSIGHTS);
};
